module.exports = __webpack_public_path__ + "static/media/bell-exclamation.8570005a.svg";